
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IRateLadderItem, IRateLadderParams, IRateLadderUpdate } from '../../types/system/rate-ladder-config';
import { IServerProductRateItem } from '../../types/crowd-source/product';

const hostUrl = getHostbaseUrl();

/**
 * 系统配置 - 费率阶梯分页
 */
export async function querySysAgentRate(params: IRateLadderParams) {
  let data = [] as IRateLadderItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IRateLadderItem[]; total: number }>(`${hostUrl}/side/sys/agentRate/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IRateLadderItem[]; total: number };
   
      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
   
  return {
    data,
    total, 
  };
}

/**
 * 系统配置 - 费率阶梯配置
 */
export async function updateSysteaAentRate(params: IRateLadderUpdate) {

  try {
    const { code, message } = await Http.post<{ data: IRateLadderItem[]; total: number }>(`${hostUrl}/side/sys/agentRate/config`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 系统配置 - 费率阶梯配置 根据代理商ID查询
 */
export async function querySysRateByAgentId(id: number) {
  let data = [] as IServerProductRateItem[];

  try {
    const { code, context, message } = await Http.post<IServerProductRateItem[]>(`${hostUrl}/side/sys/agentRate/getByAgentId`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IServerProductRateItem[];
   
      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
   
  return data;
}